export const imgList: Record<string, { pc: string; h5: string }[]> = {
    us: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1719998735797/DP2_DVH_pc.png', // DP2
            h5: 'https://websiteoss.ecoflow.com/upload/image/1719998737172/DP2_DVH_h5.png',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1719998735397/D2_pc.png', // D2
            h5: 'https://websiteoss.ecoflow.com/upload/image/1719998736372/D2_h5.png',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1719998735609/R2M_160_pc.png', // R2M 160
            h5: 'https://websiteoss.ecoflow.com/upload/image/1719998736951/R2M_160_h5.png',
        },
    ],
    ca: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1719998736178/DP_440_pc.png', // DP 400
            h5: 'https://websiteoss.ecoflow.com/upload/image/1719998735991/DP_440_h5.png',
        },
        // {
        //     pc: 'https://websiteoss.ecoflow.com/upload/image/1719998736747/D2M_220_pc.png', // D2M 220
        //     h5: 'https://websiteoss.ecoflow.com/upload/image/1719998735204/D2M_220_h5.png',
        // },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1719998736559/D2_220_pc.png', // D2 220
            h5: 'https://websiteoss.ecoflow.com/upload/image/1719998735020/D2_220_h5.png',
        },
    ],
};
